export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/three_hundred_sixty.a3d5e24.svg";